export const ResourcesSharedNames = {
  bluePig: 'animations_web_characters_characters_bluePig_blue_pig',
  yellowPig: 'animations_web_characters_yellowPig_yellow_pig',
  redPig: 'animations_web_characters_redPig_red_pig',
  bluePigButton: 'animations_web_characters_characters_bluePigButton_blue_pig_front',
  yellowPigButton: 'animations_web_buttons_yellowPigButton_yellow_pig_front',
  redPigButton: 'animations_web_buttons_redPigButton_red_pig_front',
  wolf: 'animations_web_buttons_wolf_wolf',
  whiteWolf: 'animations_web_characters_whiteWolf_white_wolf',
  door: 'animations_web_door_door',
  backgroundFirst: 'assets_shared_background_scene1',
  backgroundSecond: 'assets_shared_background_scene2',
  backgroundThird: 'assets_shared_background_scene3',
  wall: 'assets_shared_wall',
};

export const resourcesShared = [
  {
    name: ResourcesSharedNames.backgroundFirst,
    path: 'assets/shared/background_scene1.png',
  },
  {
    name: ResourcesSharedNames.backgroundSecond,
    path: 'assets/shared/background_scene2.png',
  },
  {
    name: ResourcesSharedNames.backgroundThird,
    path: 'assets/shared/background_scene3.png',
  },
  { name: ResourcesSharedNames.wall, path: 'assets/shared/wall.png' },
  {
    name: ResourcesSharedNames.bluePig,
    path: 'animations/web/characters/bluePig/blue_pig.json',
    config: {
      metadata: {
        spineAtlasFile: 'animations/web/characters/bluePig/blue_pig.atlas',
      },
    },
  },
  {
    name: ResourcesSharedNames.yellowPig,
    path: 'animations/web/characters/yellowPig/yellow_pig.json',
    config: {
      metadata: {
        spineAtlasFile: 'animations/web/characters/yellowPig/yellow_pig.atlas',
      },
    },
  },
  {
    name: ResourcesSharedNames.redPig,
    path: 'animations/web/characters/redPig/red_pig.json',
    config: {
      metadata: {
        spineAtlasFile: 'animations/web/characters/redPig/red_pig.atlas',
      },
    },
  },
  {
    name: ResourcesSharedNames.bluePigButton,
    path: 'animations/web/buttons/bluePigButton/blue_pig_front.json',
    config: {
      metadata: {
        spineAtlasFile: 'animations/web/buttons/bluePigButton/blue_pig_front.atlas',
      },
    },
  },
  {
    name: ResourcesSharedNames.redPigButton,
    path: 'animations/web/buttons/redPigButton/red_pig_front.json',
    config: {
      metadata: {
        spineAtlasFile: 'animations/web/buttons/redPigButton/red_pig_front.atlas',
      },
    },
  },
  {
    name: ResourcesSharedNames.yellowPigButton,
    path: 'animations/web/buttons/yellowPigButton/yellow_pig_front.json',
    config: {
      metadata: {
        spineAtlasFile: 'animations/web/buttons/yellowPigButton/yellow_pig_front.atlas',
      },
    },
  },
  {
    name: ResourcesSharedNames.wolf,
    path: 'animations/web/characters/wolf/wolf.json',
    config: {
      metadata: {
        spineAtlasFile: 'animations/web/characters/wolf/wolf.atlas',
      },
    },
  },
  {
    name: ResourcesSharedNames.whiteWolf,
    path: 'animations/web/characters/whiteWolf/white_wolf.json',
    config: {
      metadata: {
        spineAtlasFile: 'animations/web/characters/whiteWolf/white_wolf.atlas',
      },
    },
  },
  {
    name: ResourcesSharedNames.door,
    path: 'animations/web/door/door.json',
    config: {
      metadata: {
        spineAtlasFile: 'animations/web/door/door.atlas',
      },
    },
  },
];
